YP.EventTicketProducts = function() {
    return {
        init: function(){
            YP.ModalManager().setPreCallSuccess(YP.TypeProduct().init());
        },
    };
};

window.addEventListener("load", function(){
    if ($('#ticketing_table').length > 0) {
        YP.EventTicketProducts().init();
    }
});
